import React, { useEffect } from 'react'
import moment from 'moment'

import { Box, Grid, Typography } from '@material-ui/core'

import useProfileContext from 'src/context/ProfileContext'
import { Pallet } from 'src/api/models'
import { Barcode } from '../Barcode'

interface Props {
  obj: Pallet
  onReadyToPrint?: () => void
}

export const PalletLabel = (props: Props) => {
  const { obj, onReadyToPrint } = props
  const barcode = { barcode: obj.guid, type: 'datamatrix', displayName: '' }
  const { profile } = useProfileContext()

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className="always-page-break">
      <Box className="print-page" pt={5}>
        <Grid container justify="center" alignItems="center" spacing={2}>
          <Grid item xs={4}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item container xs={8} justify="center" alignItems="center" spacing={2}>
            <Grid item xs={12}>
              <obj.icon fontSize="large" />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h2">
                {obj.forShipping ? 'FOR SHIPPING' : 'FOR STORAGE'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h1">{obj.name}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h3">{obj.guid}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Client: {obj.client?.name}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Created On: {obj.createdOn?.format('lll')}</Typography>
          </Grid>
          {!!obj.asn && (
            <Grid item xs={12}>
              <Typography variant="h6">ASN: {obj.asn?.trackingNumber}</Typography>
            </Grid>
          )}
          {!!obj.batch && (
            <Grid item xs={12}>
              <Typography variant="h3">
                {obj.batch.batchTypeDisplay}: {obj.batch?.clientId}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography>Printed on {moment().format('lll')}</Typography>
          </Grid>
          {!!profile && (
            <Grid item xs={12}>
              <Typography>By {`${profile.fullName} <${profile.email}>`}}</Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </div>
  )
}
